var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoteExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 11.25V3H3V15H11.25V12.75C11.25 11.9216 11.9216 11.25 12.75 11.25H15ZM14.6893 12.75H12.75V14.6893L14.6893 12.75ZM3 16.5C2.17157 16.5 1.5 15.8284 1.5 15V3C1.5 2.17157 2.17157 1.5 3 1.5H15C15.8284 1.5 16.5 2.17157 16.5 3V13.0607L13.0607 16.5H3ZM5.25 12.75V11.25H9.75V12.75H5.25ZM5.25 9.75V8.25H12.75V9.75H5.25ZM5.25 6.75V5.25H12.75V6.75H5.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteExpand);
export default __webpack_public_path__ + "static/media/note-expand.a23ae20aa7a8ea419f6390661203e431.svg";
export { ForwardRef as ReactComponent };